export class PerfilModel {
    idPerfil?: number;
    descripcionPerfil: string;
    flgActivo?: boolean;
    flgNotificacion?: boolean;

    // Auditoria
    regUsuario?: number;
    regEstacion?: string;

    constructor(){
        this.idPerfil = 0;
        this.descripcionPerfil = '';
        this.flgActivo = true;
        this.flgNotificacion = false;
        this.regUsuario = 0;
        this.regEstacion = '';
    }
}